import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './StatusDotIcon.module.scss';
export const StatusDotIcon = ({ status }) => {
    return (_jsx("svg", { className: cn(styles.icon, styles[status]), width: "6", height: "6", xmlns: "http://www.w3.org/2000/svg", children: _jsx("circle", { cx: "3", cy: "3", r: "3" }) }));
};
